import { Box, Card, Typography } from "@material-ui/core";
import { Chart } from "chart.js";
import { useEffect, useRef } from "react";

export default function TopFeaturesChart({data}) {
  const chartRef = useRef(null);
  const chartInstance = useRef(null);

  const formatedData = {
    labels: data.map((item) => item.Funcionalidade),
    datasets: [
      {
        axis: "y",
        label: "Quantidade de Acessos",
        data: data.map((item) => item.QuantidadeAcesso),
        backgroundColor: "#156082",
        borderColor: "#156082",
        borderRadius: 0,
        categoryPercentage: 0.6,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    legend: {
      display: false,
    },
    tooltip: {
      callbacks: {
        label: function (context) {
          return `Acessos: ${context.raw}`;
        },
      },
    },
    scales: {
      yAxes: {
        beginAtZero: true,
        gridLines: {
          display: false,
        },
      },
      xAxes: [
        {
          grid: {
            color: "#e5e5e5",
          },
        },
      ],
    },
  };

  useEffect(() => {
    if (chartInstance.current) {
      chartInstance.current.destroy();
    }

    const ctx = chartRef.current.getContext("2d");

    chartInstance.current = new Chart(ctx, {
      type: "horizontalBar",
      data: formatedData,
      options: options,
    });

    return () => {
      if (chartInstance.current) {
        chartInstance.current.destroy();
      }
    };
  }, []);

  return (
    <Card style={{ minHeight: "350px", alignItems: "center" }}>
      <Typography variant="h3" component={Box} style={{ margin: "1rem" }}>
        Top 10 Funcionalidades
      </Typography>
      <div style={{ height: "250px", width: "330px" }}>
        <canvas ref={chartRef}></canvas>
      </div>
    </Card>
  );
}
